import { Doc } from '../pages/Doc';
import Histories from '../pages/Histories';
import Dashboard from '../pages/Dashboard';
import MyAccount from '../pages/User/MyAccount';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import StatisticsScreen from '../pages/StatisticsScreen';
import NavBar from '../components/NavBar';
import CurveLevelingGraphic from '../pages/SearchEngines/Curve_leveling_graphic';
import TableFull from '../pages/TableFull';
import { useAuth } from '../hooks/useAuth';

export default function UserRoutes(): JSX.Element {
  const { content } = useAuth()
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/doc" element={<Doc />} />
        <Route path="*" element={<Dashboard />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/histories" element={<Histories />} />
        {(content?.is_admin || content?.is_representative) && (

          <Route path="/statistics" element={<StatisticsScreen />} />
        )}        <Route
          path="/curve_leveling_graphic"
          element={<CurveLevelingGraphic />}
        />
        <Route path="/my-account/:id" element={<MyAccount />} />
        {
          content?.company && content?.can_download_full_table && (
            <Route
              path="/download-full"
              element={<TableFull />}
            />
          )
        }
      </Routes>
    </BrowserRouter>
  );
}
